function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Credit Card Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M15.6325263,0 C16.9576419,0 18,1.11238223 18,2.4544 L18,10.5456 C18,11.8876178 16.9576419,13 15.6325263,13 L2.36747368,13 C1.04235809,13 0,11.8876178 0,10.5456 L0,2.4544 C0,1.11238223 1.04235809,0 2.36747368,0 L15.6325263,0 Z M17.052,6 L0.947,6 L0.947368421,10.5456 C0.947368421,11.4360605 1.60074817,12.1333333 2.36747368,12.1333333 L15.6325263,12.1333333 C16.3992518,12.1333333 17.0526316,11.4360605 17.0526316,10.5456 L17.052,6 Z M15.6325263,0.866666667 L2.36747368,0.866666667 C1.60074817,0.866666667 0.947368421,1.56393954 0.947368421,2.4544 L0.947,3 L17.052,3 L17.0526316,2.4544 C17.0526316,1.56393954 16.3992518,0.866666667 15.6325263,0.866666667 Z",
  id: "path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Icon/Global/CreditCard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Swatches/DarkGreen",
  transform: "translate(3.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#4A4A4A",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-85.000000, -89.000000)",
  id: "Swatches/DarkGreen"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#333333",
  x: 0,
  y: 0,
  width: 191,
  height: 188
})))));

var SvgCreditCard = function SvgCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credit-card.4841028e.svg";
export { ForwardRef as ReactComponent };